import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IBrandCard, IPlan } from '../../types';
import { backend } from '../../../environments/environment';

@Injectable()
export class HomeService {

  constructor(public http: HttpClient) {

  }

  getHomeData(): Observable<any> {
    return this.http.get<any>(backend + 'featured');
  }

  getFeaturedBrands(limit: number): Observable<IBrandCard[]> {
    return this.http.get<IBrandCard[]>(backend + 'v3/brands/featured', {
      params: {
        sort: 'popularity',
        limit,
        tags: 'featured'
      }
    });
  }

  getBrandsList() {
    return this.http.get<IBrandCard[] | { brands: IBrandCard[], plans: IPlan[] }>(backend + 'v3/brands/list');
  }

}
